module.exports = __webpack_public_path__ + "img/GREEN_LIGHT.2b086fcc.png";